module.exports = __webpack_public_path__ + "img/34.7282bf38.png";